import lang_global from './_lang_global'
import auth from "@/modules/user/auth/lang/en/lang";

export default {
    "g": lang_global,
    "auth": auth,
}
